import Api  from './request'

export default class BalanceApi {
	static get() {
			return Api.post(`/api/balance/my`)
	}
  static listDetail(query) {
		return Api.post(`/api/balance/list-detail`, query)
  }
	static recharge(amt) {
		return Api.post(`/api/balance/recharge`, {
			amt: amt
		})
	}
	static getRules() {
		return Api.get(`api/wechat/setting?code=recharge_rules`)
	}
}
